import "../../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { dataTableInjectionKey as r } from "../interface.js";
import a from "../../../radio/src/Radio.js";
import { defineComponent as n, inject as i, h as c } from "../../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const s = n({
  name: "DataTableBodyRadio",
  props: {
    rowKey: {
      type: [String, Number],
      required: !0
    },
    disabled: {
      type: Boolean,
      required: !0
    },
    onUpdateChecked: {
      type: Function,
      required: !0
    }
  },
  setup(e) {
    const {
      mergedCheckedRowKeySetRef: t,
      componentId: o
    } = i(r);
    return () => {
      const {
        rowKey: d
      } = e;
      return c(a, {
        name: o,
        disabled: e.disabled,
        checked: t.value.has(d),
        onUpdateChecked: e.onUpdateChecked
      });
    };
  }
});
export {
  s as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/data-table/src/TableParts/BodyRadio.js
// module id = 1654
// module chunks = 67